import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { colorLandingBrandLine, colorLandingBrandSoft } from "src/design/tokens";
import galleryOne from "src/assets/landing/gallery-1.jpg";
import galleryTwo from "src/assets/landing/gallery-2.jpg";
import galleryThree from "src/assets/landing/gallery-3.jpg";

const TILES = [
  { src: galleryOne, altKey: "landingPage.showcase.gallery.alts.diningRoom" },
  { src: galleryTwo, altKey: "landingPage.showcase.gallery.alts.setTable" },
  { src: galleryThree, altKey: "landingPage.showcase.gallery.alts.ambience" },
];

/** Three-photo gallery strip, for the gallery & visibility tab. */
export const GalleryMedia = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 1.125,
        width: "100%",
      }}
    >
      {TILES.map((tile) => (
        <Box
          key={tile.altKey}
          sx={{
            aspectRatio: "4 / 3",
            borderRadius: "10px",
            backgroundColor: colorLandingBrandSoft,
            border: `1px solid ${colorLandingBrandLine}`,
            overflow: "hidden",
          }}
        >
          <Box
            component="img"
            src={tile.src}
            alt={t(tile.altKey)}
            loading="lazy"
            sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
          />
        </Box>
      ))}
    </Box>
  );
};
